import { useEffect, useId, useState } from "react";

type MermaidProps = {
	chart: string;
	caption?: string;
};

/** */
export default function Mermaid({ chart, caption }: MermaidProps) {
	const reactId = useId();
	const renderId = `mermaid-${reactId.replace(/[^a-zA-Z0-9_-]/g, "")}`;
	const [svg, setSvg] = useState<string>();
	const [error, setError] = useState<string>();

	useEffect(() => {
		let cancelled = false;

		void import("mermaid")
			.then(async ({ default: mermaid }) => {
				mermaid.initialize({
					startOnLoad: false,
					securityLevel: "strict",
					theme: "dark",
					themeVariables: {
						primaryColor: "#2a211b",
						primaryTextColor: "#fafafa",
						primaryBorderColor: "#ffb872",
						lineColor: "#ffb872",
						secondaryColor: "#191919",
						tertiaryColor: "#0f0f0f",
						noteBkgColor: "#24201c",
						noteTextColor: "#fafafa",
					},
				});

				const result = await mermaid.render(renderId, chart);
				if(!cancelled) { setSvg(result.svg); }
			})
			.catch((reason: unknown) => {
				if(!cancelled) {
					setError(reason instanceof Error ? reason.message : "Unable to render diagram");
				}
			});

		return () => {
			cancelled = true;
		};
	}, [chart, renderId]);

	if(error) {
		return <pre className="diagram-error">{error}</pre>;
	}

	return (
		<figure className="diagram">
			{svg ? (
				<div className="diagram-canvas" dangerouslySetInnerHTML={{ __html: svg }} />
			) : (
				<div className="diagram-loading">Rendering diagram…</div>
			)}
			{caption ? <figcaption>{caption}</figcaption> : null}
		</figure>
	);
}
